export default __webpack_public_path__ + "static/media/GRAPHIC_INSTRUCT_ATHLETE_ABOUT_SCHOOL_IP_CONTRACT.1dff7e89.png";